/**
 * Supabase relation payload normalizers.
 * Relations may come back as object | array | null — normalize before use.
 */

/**
 * Normalize a one-to-one relation (object or null).
 * PostgREST returns object for single relation, but type may be wrong.
 */
export function normalizeOneRelation<T>(raw: unknown): T | null {
  if (raw == null) return null;
  if (Array.isArray(raw)) return (raw[0] as T) ?? null;
  if (typeof raw === "object") return raw as T;
  return null;
}

/**
 * Normalize a one-to-many relation (array).
 * PostgREST returns array; handle malformed payloads.
 */
export function normalizeArrayRelation<T>(raw: unknown): T[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw as T[];
  if (typeof raw === "object") return [raw as T];
  return [];
}
